/**
 * Created by Sale on 8/29/2024
 */
import store from "./store";
import router from "./router";

export default {
    store,
    router
};